import Banner from '../sections/Banner';
import BrandsGrid from '../sections/BrandsGrid';
import ImpactStats from '../sections/ImpactStats';
import AurelixStats from '../sections/AurelixStats';
import ConnectedSystem from '../sections/ConnectedSystem';
import TextSection from '../sections/TextSection';
import ScrollServices from '../sections/ScrollServices';
import HowEverythingConnects from '../sections/HowEverythingConnects';
import MarqueeScroll from '../sections/MarqueeScroll';
import SelectedWorks from '../sections/SelectedWorks';
import WhyAurelix from '../sections/WhyAurelix';
import Features from '../sections/Features';
import About from '../sections/About';
import Works from '../sections/Works';
import Testimonials from '../sections/Testimonials';
import GlobalPresence from '../sections/GlobalPresence';
import FAQ from '../sections/FAQ';
import Gallery from '../sections/Gallery';

// import ScheduleCall from '../sections/ScheduleCall';
import BookingSection from '../sections/BookingSection';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FoundersSection from '../sections/FoundersSection';
import NewsSection from '../sections/NewsSection';
import AurelixEdge from '../sections/AurelixEdge';
import CalendarSection from '../sections/CalendarSection';


import ParagraphSection from '../sections/ParagraphSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Banner />
        <BrandsGrid />
        <ImpactStats />
        <AurelixStats />
        <ConnectedSystem />
        {/* <TextSection /> */}
        <About />
        <FoundersSection />
        <AurelixEdge />
        <Testimonials />
        <GlobalPresence />
        <ScrollServices />
        <HowEverythingConnects />
        {/* <ParagraphSection /> */}
        <SelectedWorks />
        <WhyAurelix />
        <Features />
        {/* <Works /> */}
        {/* <Gallery /> */}
        {/* <ScheduleCall /> */}
        {/* <BookingSection /> */}
        <FAQ />
        <NewsSection />
      </main>
      <Footer />
    </>
  );
}